import { createCommand } from '../../utils';
import type { Project } from '../ExternalProjectPort';
import { moduleName, setCurrentProjectId } from '../state';

interface CreateProjectCommandParams {
    name: string;
}

export const CreateProjectCommand = createCommand<CreateProjectCommandParams, Project>(
    `${moduleName}/CREATE_PROJECT`,
    async ({ name }, { dispatch, extra }) => {
        const project = await extra.externalProject.createProject(name);
        dispatch(setCurrentProjectId(project.id));

        return project;
    },
);
